<template>
    <div class="vue-donation-block">
        <div class="row">
            <div class="col-12">
                <h3>{{ supportZoaTitle }}</h3>

                <div class="custom-radios">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input v-model.number="donationTerm" type="radio" id="donation-term-once" name="donation-term-once" class="custom-control-input" value="once">
                        <label class="custom-control-label" for="donation-term-once">{{ supportZoaOptionA }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input v-model.number="donationTerm" type="radio" id="donation-term-monthly" name="donation-term-monthly" class="custom-control-input" value="monthly">
                        <label class="custom-control-label" for="donation-term-monthly">{{ supportZoaOptionB }}</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input v-model.number="donationTerm" type="radio" id="donation-term-annually" name="donation-term-annually" class="custom-control-input" value="yearly">
                        <label class="custom-control-label" for="donation-term-annually">{{ supportZoaOptionC }}</label>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-4">
                <h3>{{ amountZoaTitle }}</h3>

                <div class="row controls-wrapper">
                    <div class="col-md-9 custom-radios">

                      <zoa-donation-amount
                          v-for="(item, index) in amounts"
                          :key="index"
                          :event-bus="eventBus"
                          :amount="item.amount"
                          @donation-amount="handleDonationAmount"></zoa-donation-amount>
                    </div>

                    <div class="col-md-3 other-amount">
                        <input v-model.number="donationAmountOther" type="number" :class="{'active': otherDonationFilled}" :placeholder="amountZoaOptionOther">
                    </div>
                </div>
            </div>

            <div class="col-12 button-wrapper">
                <a :href="url" target="_blank" class="btn btn-secondary">{{ donateZoaSubmit }}</a>

                <p>{{ donateZoaCurrentStep }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DonationBlock",

    props: ['opt_1', 'opt_2', 'opt_3', 'selected', 'default_period', 'base_url'],

    data() {
        return {
            donationTerm: this.default_period,
            donationAmount: parseFloat(this[this.selected]),
            donationAmountOther: null,
            baseUrl: (!_.isEmpty(this.base_url) ? this.base_url : 'https://form.zoa.nl/donatie'),
            eventBus: new Vue(),

            amounts: [
              { amount: this.opt_1 },
              { amount: this.opt_2 },
              { amount: this.opt_3 }
            ],

            supportZoaTitle: window.Drupal.t('I support ZOA'),
            supportZoaOptionA: window.Drupal.t('Once'),
            supportZoaOptionB: window.Drupal.t('Monthly'),
            supportZoaOptionC: window.Drupal.t('Annually'),
            amountZoaTitle: window.Drupal.t('I donate'),
            amountZoaOptionOther: window.Drupal.t('Other...'),
            donateZoaSubmit: window.Drupal.t('Donate'),
            donateZoaCurrentStep: window.Drupal.t('Step 1 of 2')
        }
    },

    computed: {
        url() {
            let url = this.baseUrl + '?frequencyamounts[frequency]=' + this.donationTerm + '&frequencyamounts[amount]=';

            if (this.otherDonationFilled) {
                return url + (this.donationAmountOther * 100);
            }

            return url + (this.donationAmount * 100);
        },

        otherDonationFilled() {
            return ! _.isNil(this.donationAmountOther);
        }
    },

    mounted() {
        this.eventBus.$emit('active-amount', this.donationAmount);
    },

    methods: {
      handleDonationAmount(payload) {
        this.donationAmount = (parseFloat(payload) / 100);
        this.donationAmountOther = null;
      }
    },

    watch: {
        donationAmountOther: _.debounce(function(value) {
            if (value < 1 && ! _.isNil(value)) {
                this.donationAmountOther = 1;
                return;
            }

            if (value < 1 && _.isEmpty(value)) {
                return;
            }

            this.donationAmount = null;
            this.eventBus.$emit('remove-active-state');
        }, 200)
    }
}
</script>